import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';
import { ONBOARD_CONSTANTS } from '../app.constants';
import { HttpService } from './http.service';
import { AppService } from '../app.service';
import { ErrorService } from '../components/error/error.service';
import { LandingService } from '../components/landing/landing.service';
import { AccessibilityService } from '../services/accessibility.service';
import { PaymentSelectionComponent } from '../components/eb/paymentSelection.component';
declare let $: any;

@Injectable()
export class BuywifiService {
  private sessionValue: any;
  private passengerResponse: any;
  private offersResponse: any;
  private pointsOfferResponse: any;
  private orderResponse: any;
  private reserveResponse: any;
  private currentSegment: any;
  private price: any;
  private points: any;
  private origin: any;
  private destination: any;
  public currencyList: any;
  public connectionId: any;
  public currencyPos: any;
  public selectedCurrency: any;
  public receiptEmailAddress: any;
  public productId: any;
  public currentState: any;
  public showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;

  constructor(private appService: AppService, private landingService: LandingService, private httpService: HttpService,
    private errorService: ErrorService,
    private accessibilityService: AccessibilityService) { }

  setPassengerResponse(passengerResponse) {
    this.passengerResponse = passengerResponse;
  }

  getPassengerResponse() {
    return this.passengerResponse;
  }

  setOffersResponse(offersResponse) {
    this.offersResponse = offersResponse;
  }

  setPointsOfferResponse(pointsOfferResponse) {
    this.pointsOfferResponse = pointsOfferResponse;
  }

  getOffersResponse() {
    return this.offersResponse;
  }

  getPointsOfferResponse() {
    return this.pointsOfferResponse;
  }

  getOrderResponse() {
    return this.orderResponse;
  }

  setOrderResponse(orderResponse) {
    this.orderResponse = orderResponse;
  }

  setSessionValue(sessionvalue) {
    this.sessionValue = sessionvalue;
  }

  setReserveResponse(reserveData) {
    this.reserveResponse = reserveData;
    let checkoutId = null;
    if (this.reserveResponse && this.reserveResponse.checkoutId) {
      checkoutId = this.reserveResponse.checkoutId;
    }
    this.appService.setCheckOutId(checkoutId);
  }

  getSessionValue() {
    return (this.sessionValue) ? this.sessionValue : 0;
  }

  getCurrency(): string | undefined {
    if (this.offersResponse) {
      return this.offersResponse.currency.code;
    }
  }

  getCurrentSegment() {
    if (this.appService.isCharter || this.appService.isUnconfirmedTicket) {
      this.currentSegment = this.offersResponse;
      this.currentSegment.flightNumber = this.appService.flightResponse.flightNumber;
    } else if (this.passengerResponse) {
      const segmentId = this.passengerResponse.reservationInfo.reservationFlightSegmentId;
      for (const j in this.offersResponse.connections) {
        if (this.offersResponse.connections[j][segmentId]) {
          this.connectionId = j;
          this.currentSegment = this.offersResponse.connections[j][segmentId];
        }
      }
    }
    return this.currentSegment;
  }

  getCurrentPrice() {
    if (this.appService.isCharter || this.appService.isUnconfirmedTicket) {
      this.price = this.offersResponse.products.wifi.price;
      this.productId = this.offersResponse.products.wifi.productId;
    } else if (this.passengerResponse) {
      const segmentId = this.passengerResponse.reservationInfo.reservationFlightSegmentId;
      const passengerId = this.passengerResponse.reservationInfo.reservationPassengerId;
      for (const j in this.offersResponse.products.wifi.offers.connections) {
        if (this.offersResponse.products.wifi.offers.connections[j].segments[segmentId]) {
          const segmentLevel = this.offersResponse.products.wifi.offers.connections[j].segments[segmentId];
          this.price = segmentLevel.passengers[passengerId].WIFI.price;
          this.productId = segmentLevel.passengers[passengerId].WIFI.id;
        }
      }
    }
    return this.price;
  }

  getCurrentPoints() {
    if (this.showEBforPointsBuy) {
      this.points = this.pointsOfferResponse.points;
    }
    return this.points;
  }

  getOriginFromFlightResponse() {
    const flightResponseData = this.appService.getFlightResponse();
    return this.origin = flightResponseData.origin;
  }
  getDestinationFromFlightResponse() {
    const flightResponseData = this.appService.getFlightResponse();
    return this.destination = flightResponseData.destination;
  }

  getProductId() {
    return this.productId;
  }

  getCurrencyList() {
    if ((this.passengerResponse || this.appService.isCharter || this.appService.isUnconfirmedTicket) && this.offersResponse.products.wifi.links) {
      this.currencyList = this.offersResponse.products.wifi.links;
    } else {
      this.currencyList = [];
    }
    return this.currencyList;
  }

  getCheckOutId() {
    let checkoutId = '';
    if (this.reserveResponse && this.reserveResponse.checkoutId) {
      checkoutId = this.reserveResponse.checkoutId;
    }
    return checkoutId;
  }

  getDefaultError(): any[] {    
    return [{ 'errorCode': ONBOARD_CONSTANTS.DEFAULT_ERROR }];
  }

  getErrorMessage(errorcode): any[] {    
    return [{ 'errorCode': errorcode }];
  }

  hideHeaderFooter() {
    $('#header-show, #sas-header-wrapper, #sas-footer-wrapper, #landingBanner').hide();
  }

  getDeviceResponse() {
    return this.appService.getDeviceResponse();
  }

  setChatBotShow() {
    $(document).trigger('onboardBotShow');
  }

  setChatBotHide() {
    $(document).trigger('onboardBotHide');
  }

  updateDeviceDetails() {
    const deviceToken = this.appService.getDeviceToken();
    const getDevicRequestEntity = this.landingService.getDeviceRequestEntity(deviceToken);
    return this.httpService.getData(getDevicRequestEntity).subscribe(
      getDeviceResponse => {
        if (getDeviceResponse.errors) {
          this.errorService.addError(getDeviceResponse.errors);
          this.appService.hideLoader();
          return false;
        } else {
          return getDeviceResponse;
        }
      },
      error => {
        return this.setDefaultError();
      }
    );
  }

  updateFlightDetails(getDeviceResponse) {
    const chatRequestUrl = this.landingService.getChatRequestUrl(getDeviceResponse);
    return this.httpService.getData(chatRequestUrl).map(
      flightResponse => {
        if (flightResponse.errors) {
          this.errorService.addError(getDeviceResponse.errors);
          return false;
        } else {
          this.landingService.setGetDeviceResponse(getDeviceResponse);
          this.appService.setGetDeviceResponse(getDeviceResponse);
          this.appService.setFlightResponse(flightResponse);
          this.landingService.getNetFlixBanner(getDeviceResponse.status.code);
        }
        this.appService.hideLoader();
        return flightResponse;
      },
      error => {
        return this.setDefaultError();
      }
    );
  }

  setDefaultError() {
    this.errorService.addError(this.landingService.getDefaultError());
    this.appService.hideLoader();
    return false;
  }

  checkReleaseCall() {
    const checkoutId = this.appService.getCheckOutId();
    if (ONBOARD_CONSTANTS.ANCFULL_FILLMENT && checkoutId && checkoutId !== '') {
      this.doReleaseCall(checkoutId).subscribe(
        checkoutCallResponse => {
          this.setReserveResponse(null);
          this.appService.hideLoader();
        });
    }
  }

  releaseCallRequest(checkoutId) {
    const checkoutUrl = ONBOARD_CONSTANTS.RELEASE_URL.replace('<<CHECKOUTID>>', checkoutId);
    const saveCardRequest = {
      url: environment.apiBaseUrl + checkoutUrl,
      data: {
        'reason': 'FUNBACK'
      },
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    }
    return saveCardRequest;
  }

  doReleaseCall(checkoutId) {
    this.appService.showLoader();
    const releaseCallRequest = this.releaseCallRequest(checkoutId);
    return this.httpService.postData(releaseCallRequest).map(
      releaseCallResponse => {
        this.appService.hideLoader();
        return releaseCallResponse;
      },
      error => {
        this.appService.hideLoader();
        return error;
      }
    );
  }

  getCurrentState() {
    return this.currentState;
  }

  setCurrentState(currentState) {
    this.currentState = currentState;
  }

  readmoreContent(pos: any, lang: any) {
    const readmoreUrl = `/content/flysas-${pos}/${lang}/tx-ui/wifi-readmore.content.html`;
    const readmoreJsUrl = `/etc/clientlibs/flysas/transaction-integration/modal-content.js`;
    const readmoreCssUrl = `/etc/clientlibs/flysas/transaction-integration/modal-content.css`;
    this.appService.showLoader();
    this.httpService.getHtml(readmoreUrl).subscribe(readmoreUrlData => {
      const link = document.createElement('link');
      link.type = 'text/css';
      link.href = readmoreCssUrl;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
      document.getElementById('readmoreContent').innerHTML = readmoreUrlData;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = readmoreJsUrl;
      document.head.appendChild(script);
      this.appService.hideLoader();
      this.accessibilityService.focus('.readmore-content .accordion li:first-child a');
    },
      error => {
        this.appService.hideLoader();
      });

  }

}
